import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const FeatureHome = () => {
  const [activeTab, setActiveTab] = useState("home");
  const [unreadMessages, setUnreadMessages] = useState(3);
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCity = location.state?.selectedCity || "montreal";

  const cityInfo = {
    montreal: {
      name: "Montreal",
      subtitle: "European charm meets North America",
    },
    newyork: { name: "New York", subtitle: "The city that never sleeps" },
    toronto: { name: "Toronto", subtitle: "Multicultural metropolis" },
    lasvegas: { name: "Las Vegas", subtitle: "Entertainment capital" },
  };

  const currentCity = cityInfo[selectedCity] || cityInfo.montreal;

  const features = [
    {
      id: "reviews",
      icon: "bi-star",
      title: "City Review",
      description:
        "Read authentic reviews and ratings from fellow travelers to discover the best spots in any city.",
    },
    {
      id: "planner",
      icon: "bi-calendar-check",
      title: "FIT Trip Planner",
      description:
        "Create personalized itineraries tailored to your interests, budget, and travel style.",
    },
    {
      id: "guide",
      icon: "bi-compass",
      title: "AI-Powered Real-Time Self-Guiding",
      description:
        "Get intelligent, real-time navigation and recommendations as you explore.",
    },
    {
      id: "messenger",
      icon: "bi-chat-dots",
      title: "My Messenger",
      description:
        "Connect with locals and other travelers to share tips, experiences, and travel insights.",
    },
  ];

  const handleFeatureClick = (featureId) => {
    switch (featureId) {
      case "reviews":
        navigate("/city-reviews");
        break;
      case "planner":
        navigate("/chat", {
          state: {
            selectedCity: selectedCity,
            cityName: currentCity.name,
            fromFeatureHome: true,
          },
        });
        break;
      case "guide":
        window.open("https://citygetaway-frontend.vercel.app/day/1", "_blank");
        break;
      case "messenger":
        navigate("/messenger");
        break;
      default:
        break;
    }
  };

  const handleStartPlanning = () => {
    navigate("/chat", {
      state: {
        selectedCity: selectedCity,
        cityName: currentCity.name,
        fromFeatureHome: true,
      },
    });
  };

  return (
    <>
      <style>{`
                .feature-home-container {
                    width: 100%;
                    max-width: 430px;
                    height: 100vh;
                    height: 100dvh;
                    margin: 0 auto;
                    background: #f8f8f8;
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    overflow: hidden;
                }
                
                .bg-decoration {
                    position: absolute;
                    width: 250px;
                    height: 250px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #E3E3E3 0%, #EAEAEA 100%);
                    opacity: 0.4;
                    z-index: 0;
                }
                
                .bg-decoration-1 {
                    top: -100px;
                    right: -80px;
                }
                
                .bg-decoration-2 {
                    bottom: 100px;
                    left: -100px;
                }
                
                .feature-header {
                    background: rgba(255, 255, 255, 0.8);
                    backdrop-filter: blur(20px);
                    -webkit-backdrop-filter: blur(20px);
                    padding: 50px 24px 24px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
                    position: relative;
                    z-index: 10;
                }
                
                .header-top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                }
                
                .header-logo {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                
                .logo-img {
                    width: 32px;
                    height: 32px;
                    object-fit: contain;
                }
                
                .logo-text {
                    font-size: 16px;
                    font-weight: 400;
                    color: #2d2d2d;
                }
                
                .settings-btn {
                    width: 36px;
                    height: 36px;
                    background: #f0f0f0;
                    border: none;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s;
                    color: #6a6a6a;
                }
                
                .settings-btn:hover {
                    background: #e8e8e8;
                }
                
                .header-content {
                    margin-top: 8px;
                }
                
                .header-title {
                    font-size: 24px;
                    font-weight: 300;
                    color: #1a1a1a;
                    margin-bottom: 4px;
                }
                
                .header-subtitle {
                    font-size: 14px;
                    color: #7a7a7a;
                    font-weight: 400;
                }
                
                .features-section {
                    flex: 1;
                    padding: 20px;
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    position: relative;
                    z-index: 1;
                }
                
                .feature-card {
                    background: rgba(255, 255, 255, 0.7);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    border-radius: 16px;
                    border: 1px solid rgba(255, 255, 255, 0.8);
                    padding: 18px;
                    margin-bottom: 14px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    opacity: 0;
                    transform: translateY(20px);
                    animation: slideUp 0.5s ease forwards;
                }
                
                .feature-card:nth-child(1) { animation-delay: 0.1s; }
                .feature-card:nth-child(2) { animation-delay: 0.15s; }
                .feature-card:nth-child(3) { animation-delay: 0.2s; }
                .feature-card:nth-child(4) { animation-delay: 0.25s; }
                
                @keyframes slideUp {
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .feature-card:hover {
                    background: rgba(255, 255, 255, 0.85);
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
                }
                
                .feature-card:active {
                    transform: scale(0.98);
                }
                
                .feature-content {
                    display: flex;
                    align-items: flex-start;
                    gap: 14px;
                }
                
                .feature-icon-wrapper {
                    width: 42px;
                    height: 42px;
                    background: #f0f0f0;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }
                
                .feature-icon {
                    font-size: 20px;
                    color: #4a4a4a;
                }
                
                .feature-text {
                    flex: 1;
                }
                
                .feature-title {
                    font-size: 15px;
                    font-weight: 500;
                    color: #2d2d2d;
                    margin-bottom: 6px;
                }
                
                .feature-description {
                    font-size: 13px;
                    color: #7a7a7a;
                    line-height: 1.4;
                    font-weight: 400;
                }
                
                .start-planning-wrapper {
                    padding: 0 20px 20px;
                    position: relative;
                    z-index: 10;
                }
                
                .start-planning-btn {
                    width: 100%;
                    padding: 18px;
                    background: #2d2d2d;
                    border: none;
                    border-radius: 20px;
                    color: white;
                    font-size: 15px;
                    font-weight: 400;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                }
                
                .start-planning-btn:hover {
                    background: #1a1a1a;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
                }
                
                .start-planning-btn:active {
                    transform: scale(0.98);
                }
                
                .bottom-nav {
                    background: white;
                    border-top: 1px solid #f0f0f0;
                    display: flex;
                    justify-content: space-around;
                    padding: 6px 0;
                    position: relative;
                    z-index: 10;
                    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.03);
                }
                
                .nav-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 6px 8px;
                    cursor: pointer;
                    transition: all 0.2s;
                    background: none;
                    border: none;
                    color: #9ca3af;
                    position: relative;
                    min-width: 50px;
                    flex: 1;
                }
                
                .nav-item::before {
                    content: '';
                    position: absolute;
                    top: -1px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 0;
                    height: 2px;
                    background: #667eea;
                    transition: width 0.3s;
                }
                
                .nav-item.active::before {
                    width: 30px;
                }
                
                .nav-item.active {
                    color: #667eea;
                }
                
                .nav-icon {
                    font-size: 20px;
                    margin-bottom: 3px;
                    transition: transform 0.2s;
                    position: relative;
                }
                
                .nav-item.active .nav-icon {
                    transform: scale(1.1);
                }
                
                .nav-label {
                    font-size: 9px;
                    font-weight: 500;
                    letter-spacing: 0.2px;
                }
                
                .message-badge {
                    position: absolute;
                    top: -4px;
                    right: -8px;
                    background: #ff4757;
                    color: white;
                    font-size: 10px;
                    font-weight: 600;
                    padding: 2px 5px;
                    border-radius: 10px;
                    min-width: 16px;
                    height: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 2px solid white;
                    animation: pulse 2s infinite;
                }
                
                @keyframes pulse {
                    0% {
                        box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
                    }
                    70% {
                        box-shadow: 0 0 0 8px rgba(255, 71, 87, 0);
                    }
                    100% {
                        box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
                    }
                }
                
                @supports (padding: max(0px)) {
                    .feature-header {
                        padding-top: max(50px, env(safe-area-inset-top));
                    }
                    
                    .bottom-nav {
                        padding-bottom: max(8px, env(safe-area-inset-bottom));
                    }
                }
            `}</style>

      <div className="feature-home-container">
        <div className="bg-decoration bg-decoration-1"></div>
        <div className="bg-decoration bg-decoration-2"></div>

        <div className="feature-header">
          <div className="header-top">
            <div className="header-logo">
              <img
                src="/assets/logocity.jpg"
                alt="CityGetAway Logo"
                className="logo-img"
              />
              <span className="logo-text">CityGetAway</span>
            </div>
            <button className="settings-btn">
              <i className="bi bi-gear"></i>
            </button>
          </div>
          <div className="header-content">
            <h1 className="header-title">Explore {currentCity.name}</h1>
            <p className="header-subtitle">{currentCity.subtitle}</p>
          </div>
        </div>

        <div className="features-section">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="feature-card"
              onClick={() => handleFeatureClick(feature.id)}
            >
              <div className="feature-content">
                <div className="feature-icon-wrapper">
                  <i className={`bi ${feature.icon} feature-icon`}></i>
                </div>
                <div className="feature-text">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="start-planning-wrapper">
          <button className="start-planning-btn" onClick={handleStartPlanning}>
            <span>Start Planning My Trip</span>
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>

        <div className="bottom-nav">
          <button
            className={`nav-item ${activeTab === "discover" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("discover");
              navigate("/explore", { state: { selectedCity } });
            }}
          >
            <i className="bi bi-compass nav-icon"></i>
            <span className="nav-label">Discover</span>
          </button>

          <button
            className={`nav-item ${activeTab === "plan" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("plan");
              navigate("/trip-planner", {
                state: {
                  selectedCity: selectedCity,
                  cityName: currentCity.name,
                  fromFeatureHome: true,
                },
              });
            }}
          >
            <i className="bi bi-calendar3 nav-icon"></i>
            <span className="nav-label">Plan</span>
          </button>

          <button
            className={`nav-item ${activeTab === "community" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("community");
              navigate("/community");
            }}
          >
            <i className="bi bi-people nav-icon"></i>
            <span className="nav-label">Community</span>
          </button>

          <button
            className={`nav-item ${activeTab === "bookings" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("bookings");
              navigate("/booking-cart");
            }}
          >
            <i className="bi bi-ticket-perforated nav-icon"></i>
            <span className="nav-label">Bookings</span>
          </button>

          <button
            className={`nav-item ${activeTab === "messages" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("messages");
              setUnreadMessages(0);
              navigate("/notifications");
            }}
          >
            <div style={{ position: "relative" }}>
              <i className="bi bi-envelope nav-icon"></i>
              {unreadMessages > 0 && (
                <span className="message-badge">
                  {unreadMessages > 9 ? "9+" : unreadMessages}
                </span>
              )}
            </div>
            <span className="nav-label">Messages</span>
          </button>

          <button
            className={`nav-item ${activeTab === "profile" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("profile");
              navigate("/profile", {
                state: { selectedCity: selectedCity },
              });
            }}
          >
            <i className="bi bi-person nav-icon"></i>
            <span className="nav-label">Profile</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default FeatureHome;
